import { useCallback } from "react"
import { graphql } from "relay-runtime"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { SetSteeringLevelsInput } from "@/modules/admin/capacity/services/__generated__/useSetSteeringLevelsMutation.graphql"

const mutation = graphql`
  mutation useSetSteeringLevelsMutation($inputs: [SetSteeringLevelsInput!]!) {
    setSteeringLevels(inputs: $inputs) {
      steeringLevel {
        id
        level
        language
        levelValue
        isAutomatic
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`

export function useSetSteeringLevelsMutation() {
  const [commit] = useMutationWithErrorDialog(mutation)

  return useCallback(
    (inputs: SetSteeringLevelsInput[], handleComplete?: () => void) => {
      commit({
        variables: {
          inputs,
        },
        onCompleted: handleComplete,
      })
    },
    [commit],
  )
}
